import {
  LayoutDashboard,
  HelpCircle,
  Settings,
  Wrench,
  Users,
  Brain,
  ClipboardCheck,
  Bell,
  Book,
  ShieldCheck,
  CreditCard,
  Bot,
  SlidersHorizontal,
  BadgeDollarSign,
  BarChart3,
  LayoutTemplate,
  Ghost,
  // Cpu,  // 【2026-07-04 暂时下线·系统引擎菜单，恢复时取消注释】
  // Gift, // 【2026-07-04 暂时下线·激励配置菜单，恢复时取消注释】
  ScrollText,
} from 'lucide-react'
import { type SidebarData } from '../types'

export const sidebarData: SidebarData = {
  navGroups: [
    {
      title: '主页',
      items: [
        {
          title: '探索发现',
          url: '/',
          icon: LayoutDashboard,
        },
        {
          title: '我的世界',
          url: '/workshop',
          icon: Brain,
        },
        {
          title: '元点账户',
          url: '/payment',
          icon: Wrench,
        },
      ],
    },
    {
      title: '我的',
      items: [
        // 私信箱已下线：管理员站内信统一并入右上角铃铛「通知与公告」
        {
          title: '设置',
          icon: Settings,
          url: '/settings',
        },
        {
          title: '帮助中心',
          url: '/help-center',
          icon: HelpCircle,
        },
      ],
    },
    {
      title: '管理',
      roles: ['admin', 'super_admin'],
      items: [
        {
          title: '用户管理',
          url: '/users',
          icon: Users,
        },
        {
          title: '引擎审核',
          url: '/review',
          icon: ClipboardCheck,
        },
        {
          title: '公告管理',
          url: '/admin-announcement',
          icon: Bell,
        },
        {
          title: '提示词管理',
          url: '/prompts',
          icon: Book,
        },
        {
          title: '模板管理',
          url: '/admin/templates',
          icon: LayoutTemplate,
        },
        {
          title: '游客管理',
          url: '/admin/guest-management',
          icon: Ghost,
        },
        // 【2026-07-04 暂时下线：系统引擎（无下游消费的孤岛表）/ 激励配置（未启用）——
        //   仅隐藏后台菜单入口，后端与数据不动；恢复时取消本段与顶部 Cpu/Gift import 的注释即可。
        //   注：路由本身仍存在，直接输入 URL 仍可达；如需硬拦截再加 beforeLoad 守卫。】
        // {
        //   title: '系统引擎',
        //   url: '/admin/system-engines',
        //   icon: Cpu,
        // },
        // {
        //   title: '激励配置',
        //   url: '/admin/incentive',
        //   icon: Gift,
        // },
        {
          title: '审计日志',
          url: '/admin/audit-logs',
          icon: ScrollText,
        },
        {
          title: '充值订单',
          url: '/recharge-orders',
          icon: CreditCard,
        },
        {
          title: 'AI 厂商管理',
          url: '/admin/ai-providers',
          icon: Bot,
        },
        {
          title: '系统配置',
          url: '/admin/system-configs',
          icon: SlidersHorizontal,
        },
        {
          title: '帮助中心管理',
          url: '/admin/help-center',
          icon: HelpCircle,
        },
        {
          title: '创作者分成',
          url: '/admin/creator-earnings',
          icon: BadgeDollarSign,
        },
        {
          title: '余额分析',
          url: '/analytics',
          icon: BarChart3,
        },
      ],
    },
    {
      title: '超级管理',
      roles: ['super_admin'],
      items: [
        {
          title: '管理员权限',
          url: '/super-admin/admins',
          icon: ShieldCheck,
        },
      ],
    },
  ],
}
